<template>
  <div class="app flex-row align-items-center">
    <div class="container mt-4">
      <b-row class="justify-content-center">
        <b-col md="12">
          <b-card no-body class="mx-4">
            <b-card-body class="p-4">
              <b-form>
                <div class="row">
                  <div class="col-md-6">
                    <img
                      src="assets/img/logo-erp.png"
                      height="70"
                      alt="EkosSystem Logo"
                    />
                  </div>
                  <div class="col-md-6 text-right">
                    <h5>
                      <p class="text-muted mt-5">Demo/Trial Registration</p>
                    </h5>
                  </div>
                </div>

                <b-row>
                  <b-col lg="6">
                    <b-form-group label-cols="3" label="Company Name">
                      <b-form-input
                        v-model="model.company"
                        :state="!$v.model.company.$error"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group label-cols="3" label="Billing Address">
                      <b-form-input
                        v-model="model.compaddr1"
                        :state="!$v.model.compaddr1.$error"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group label-cols="3">
                      <b-form-input v-model="model.compaddr2"></b-form-input>
                    </b-form-group>
                    <b-form-group
                      label-cols="3"
                      label-align-xl="right"
                      label="&nbsp;"
                    >
                      <b-form-input v-model="model.compaddr3"></b-form-input>
                    </b-form-group>
                    <b-form-group label-cols="3" label="Company Phone">
                      <b-row>
                        <b-col class="pr-1" cols="5"
                          ><b-form-input
                            v-model="model.compphone"
                            :state="!$v.model.compphone.$error"
                          ></b-form-input
                        ></b-col>
                        <b-col class="pl-1" cols="7">
                          <b-form-group label-cols="3" label="Fax">
                            <b-form-input
                              v-model="model.compfax"
                            ></b-form-input>
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </b-form-group>
                  </b-col>
                  <b-col lg="6">
                    <b-form-group label-cols="3" label="Contact Person">
                      <b-form-input
                        v-model="model.contact_name"
                        :state="!$v.model.contact_name.$error"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group
                      label-cols="3"
                      label-align-lg="right"
                      label="Contact Number"
                    >
                      <b-form-input
                        v-model="model.contact_number"
                        :state="!$v.model.contact_number.$error"
                        placeholder="Mobile Phone Number"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group label-cols="3" label="Contact Email">
                      <b-form-input
                        v-model="model.compemail"
                        :state="!$v.model.compemail.$error"
                        type="email"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group
                      label-cols="4"
                      label-align-lg="right"
                      label="Requested Login Name"
                    >
                      <b-form-input
                        v-model="model.username"
                        value=""
                        :state="!$v.model.username.$error"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-form-row>
                  <b-col md="6"> </b-col>
                  <b-col md="1">
                    <button
                      v-if="saveEnabled"
                      class="btn btn-primary mr-1"
                      @click.stop="save()"
                    >
                      <i class="fa fa-save"></i> Submit
                    </button>
                  </b-col>
                  <b-col md="5">
                    <div class="ml-5 mt-1">
                      Already have an account?
                      <router-link :to="{ name: 'page.login' }"
                        >Log In</router-link
                      >
                    </div>
                  </b-col>
                </b-form-row>
              </b-form>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import registration from "../apis/registration";
import { validationMixin } from "vuelidate";
import {
  required,
  minValue,
  maxLength,
  numeric,
} from "vuelidate/lib/validators";
import toastr from "mini-toastr";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    model: {
      company: { required },
      compaddr1: { required },
      compphone: { required },
      compemail: { required },
      contact_name: { required },
      contact_number: { required },
      username: { required },
    },
  },
  data() {
    return {
      horizontal: true,
      lkuHelitypeShow: false,
      saveEnabled: true,
      model: {},
    };
  },
  computed: {
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
  },
  methods: {
    save: async function () {
      this.model.compemail_name =
        this.model.compemail_name || this.model.company;
      this.model.compemail_address =
        this.model.compemail_address ||
        this.model.compaddr1 + this.model.compaddr2 + this.model.compaddr3;
      if (this.invalidModel) {
        console.log("validation  : ", this.$v.model);
        console.log("model : ", this.model);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
      } else {
        try {
          const data = {};
          for (var key in this.model) {
            data[key] = this.model[key];
          }
          await registration.save(data);
          toastr.success(
            "Submit data successfully, our team will contact you soon"
          );
          this.close();
        } catch (error) {
          if (error.message) {
            toastr.error(error.message, "ERROR", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR", 10000);
          }
        }
      }
    },
    close() {
      router.push({ name: "page.login" });
    },
  },
};
</script>
